import { render, staticRenderFns } from "./PricingPlanCardList.vue?vue&type=template&id=22a0f795&scoped=true"
import script from "./PricingPlanCardList.vue?vue&type=script&lang=js"
export * from "./PricingPlanCardList.vue?vue&type=script&lang=js"
import style0 from "./PricingPlanCardList.vue?vue&type=style&index=0&id=22a0f795&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a0f795",
  null
  
)

export default component.exports